export default __webpack_public_path__ + "static/1682-1418af34e0351215a076189db57f82e2.gif";